<footer class="footer" [ngClass]="{'powered-by': empresa.exibirPoweredBy}">
  <div  >
    <div class="minimo-produto" *ngIf="obtenhaValorMinimoVenda() && !itemPedido.brinde"
         [class.atingido]="faltaParaValorMinimo() === 0">
      <div class="texto" *ngIf="faltaParaValorMinimo() > 0">
        <span><i class="fas fa-coins mr-1"></i>Valor mínimo: <b>{{obtenhaValorMinimoVenda() | currency: 'BRL'}}</b></span>
        <span class="falta">faltam {{faltaParaValorMinimo() | currency: 'BRL'}}</span>
      </div>
      <div class="texto comemoracao" *ngIf="faltaParaValorMinimo() === 0">
        <span class="mensagem">
          <span class="emoji" aria-hidden="true">🎉</span>
          Valor mínimo de <b>&nbsp;{{obtenhaValorMinimoVenda() | currency: 'BRL'}}&nbsp;</b> atingido!
        </span>
        <span class="confetes" aria-hidden="true">
          <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        </span>
      </div>
      <div class="barra">
        <div class="progresso" [style.width.%]="percentualValorMinimo()"></div>
      </div>
    </div>
    <p *ngIf="mensagemErro" class="text-danger"><b>{{mensagemErro}}</b></p>
    <div class="row">
      <div style="display: inline-flex">
        <div class="col flex-fixed-width-item pl-0 pr-0 " [ngClass]="{'com-unidade': exibirUnidade()}"   >
          <button class="btn btn-outline-light decre"  (click)="diminuirQtde()" [disabled]="!podeDiminuirQuantidade()"><i class="fas fa-minus"></i></button>
          <div  (click)="informarPeso()" class="input">
            {{itemPedido.qtde}} <span *ngIf="exibirUnidade()"> {{itemPedido.produto.unidadeMedida.sigla}}</span>
          </div>

          <button class="btn btn-outline-light incre"  (click)="aumentarQtde()"
                  [disabled]="!podeAumentarQuantidade()">
            <i class="fas fa-plus" ></i></button>
        </div>
      </div>
      <div class="col">
        <button class="btn btn-primary btn-block" (click)="adicionarProduto()"  [disabled]="produto.indisponivel || adicionandoProduto" >
          Adicionar ( <span *ngIf="!itemPedido.brinde">{{itemPedido.total | currency: 'BRL'}}</span>
                       <span *ngIf="itemPedido.brinde">{{itemPedido.valorResgatado }} {{itemPedido.produto.acumulo}}</span>)
        </button>
      </div>
    </div>
  </div>

</footer>

<app-powered-by></app-powered-by>

<div style="width: 100%;height: 70px;" *ngIf="isMobile">
  &nbsp;
</div>


<div id="alertaFechado" class="modal fade" tabindex="-1" role="dialog"   aria-modal="true">
  <div class="modal-dialog" style="border: solid 1px #f9f9f9;border-radius: 5px;">
    <div class="modal-content">
      <div class="modal-body p-4">
        <div class="text-center">
          <i class="dripicons-information h1 text-info"></i>
          <h4 class="mt-2"  >{{mensagemAbrirPedidos}}</h4>
          <p class="mt-3">Continue olhando nosso cardápio à vontade.</p>
          <button type="button" class="btn btn-info my-2" data-dismiss="modal" >Continuar</button>

          <button class="btn btn-primary ml-2" *ngIf="modoVisualizacao">
            <app-exibir-whatsapp [empresa]="empresa" [light]="true"></app-exibir-whatsapp>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
